// @flow

import React from 'react'
import styled from 'styled-components'
import Colors from 'components/styles/colors'
import { mediaMin } from 'frontend_core/dist/styles/media'
import { spacing, fontSize } from 'frontend_core/dist/styles/variables'
import { Input } from 'antd'
import Button from 'components/atoms/Button'
import Modal from 'components/molecules/Modal'
import Message from 'components/atoms/Message'
import { containerIds } from 'redux/modules/ui'

const ModalFormTitle = styled.h2`
  color: ${Colors.black};
  text-align: center;
  font-size: ${fontSize.medium_2}px;
  font-weight: bold;
  ${mediaMin.phone`
    font-size: ${fontSize.large_2}px;
  `};
`

const ModalFormText = styled.p`
  text-align: center;
  margin-top: ${spacing.small_3}px;
  color: ${Colors.gray9};
  font-size: 12px;
  line-height: 1.477;
`

const ButtonWrapper = styled.div`
  max-width: 400px;
  margin: ${spacing.medium_2}px auto 0;
  ${mediaMin.phone`
    margin-top: ${spacing.large}px;
  `};
`

const ButtonContainer = styled.div`
  display: inline-block;
  width: 50%;
  &:nth-child(2n) {
    padding: 0 0 0 ${spacing.small / 2}px;
  }
  &:nth-child(2n-1) {
    padding: 0 ${spacing.small / 2}px 0 0;
  }
  ${mediaMin.phone`
    &:nth-child(2n) {
      padding: 0 0 0 ${spacing.small}px;
    }
    &:nth-child(2n-1) {
      padding: 0 ${spacing.small}px 0 0;
    }
  `};
`

const InputWrapper = styled.div`
  margin-top: ${spacing.medium_2}px;
`

const MessageWrapper = styled.div`
  margin-top: ${spacing.small_2}px;
`

export type PropTypes = {
  title: string,
  textList?: Array<string>,
  positiveButton: {
    text: string,
    onClick: Function,
  },
  negativeButton: {
    text: string,
    onClick: Function,
  },
  onClickClose: Function,
  onChange: Function,
  placeholder?: string,
  isActive?: boolean,
  errorMessage?: string,
  value?: string,
}

export default class ModalForm extends React.Component<PropTypes> {
  componentDidUpdate(prevProps: PropTypes) {
    if (prevProps.isActive === true && this.props.isActive === false) {
      this.preventBarrage = false
    }
  }

  preventBarrage: any

  render() {
    const {
      title,
      textList,
      negativeButton,
      positiveButton,
      placeholder,
      isActive,
      onClickClose,
      onChange,
      errorMessage,
      value,
    } = this.props

    return (
      <Modal isActive={isActive} onClickClose={onClickClose}>
        <ModalFormTitle>{title}</ModalFormTitle>
        <ModalFormText>
          {textList.map((text, i) => (
            <span key={`dialogContent${i}`}>
              {text}
              {i < textList.length && <br />}
            </span>
          ))}
        </ModalFormText>
        <InputWrapper>
          <Input
            size="large"
            placeholder={placeholder}
            onChange={onChange}
            value={value}
          />
        </InputWrapper>
        {errorMessage && (
          <MessageWrapper>
            <Message errorText={errorMessage} />
          </MessageWrapper>
        )}
        <ButtonWrapper>
          {negativeButton && (
            <ButtonContainer>
              <Button
                onClick={negativeButton.onClick}
                buttonType="medium"
                tag="button"
                colorType="gray"
                fullWidthSp
                fullWidthPc
              >
                {negativeButton.text}
              </Button>
            </ButtonContainer>
          )}
          {positiveButton && (
            <ButtonContainer>
              <Button
                onClick={() => {
                  if (!this.preventBarrage && positiveButton.onClick) {
                    this.preventBarrage = true
                    positiveButton.onClick()
                  }
                }}
                buttonType="medium"
                tag="button"
                colorType="blue"
                fullWidthSp
                fullWidthPc
              >
                {positiveButton.text}
              </Button>
            </ButtonContainer>
          )}
        </ButtonWrapper>
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/organisms/ModalForm/index.jsx